import { render, staticRenderFns } from "./Livescore.vue?vue&type=template&id=67f7bb04&scoped=true&"
import script from "./Livescore.vue?vue&type=script&lang=js&"
export * from "./Livescore.vue?vue&type=script&lang=js&"
import style0 from "./Livescore.vue?vue&type=style&index=0&id=67f7bb04&prod&scoped=true&lang=css&"
import style1 from "./Livescore.vue?vue&type=style&index=1&id=67f7bb04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7bb04",
  null
  
)

export default component.exports